import WixSDK from 'shared/utils/wix-sdk';


const uid = WixSDK.Utils.getInstanceValue('uid');


export const REFRESH_EVENT = 'refreshOnLoginEvents';


export function storeForReload(data) {
  WixSDK.PubSub.publish(REFRESH_EVENT, {
    uid,
    stored: data,
  }, true);
}



// WEBPACK FOOTER //
// ./src/widget/utils/reload.js